
<div fxFlex="row" fxLayoutGap="5px">
    <button kendoButton  icon="edit" (click)="edit()"></button>
    <label  *ngIf="!!caption" >{{ caption | translate}}</label>
    <app-loading-panel [isLoading]="isLoading" [size]="'small'"></app-loading-panel>
    
    <strong *ngIf="!isLoading && currentPeriodicalValue?.calculationTypeId == 1">{{currentPeriodicalValue.value | percent : '1.2-2' }}</strong>
    <strong *ngIf="!isLoading && currentPeriodicalValue?.calculationTypeId == 2">{{currentPeriodicalValue.value | number : '1.2-2' }}</strong>
    <i *ngIf="currentPeriodicalValue">({{ currentPeriodicalValue.fromDate | date: "yyyy-MM-dd"}})</i>
</div>
   
    <!-- <kendo-numerictextbox 
    [id]="formControlName"
    [ngClass]="{'fx-fill': settings.fxFill}"  
     [format]="settings.format" 
     [formControl]="control"
     [readonly]="settings.readonly"  
     [step]="settings.step"
     [min]="settings.min"
     [max]="settings.max"
     (valueChange)="onChange($event)"
     (blur)="onBlur()">
</kendo-numerictextbox> -->

<div kendoDialogContainer #editPeriodicalDialog></div>
